module.exports = __webpack_public_path__ + "img/local-right.7ac1e722.svg";